import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=033313ba&scoped=true&"
import script from "./change-password.vue?vue&type=script&lang=js&"
export * from "./change-password.vue?vue&type=script&lang=js&"
import style0 from "./change-password.vue?vue&type=style&index=0&id=033313ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033313ba",
  null
  
)

export default component.exports